// Financial display caches are invalidated by every known modifying route.
// Keep POST reads separate from writes because many existing reads use POST.
export const invalidatesScreenReads = (method, url) => {
  const route = (url || '').split('?')[0].replace(/^\/?api\//, '').replace(/^\/?/, '/');
  if (['put', 'delete', 'patch'].includes((method || '').toLowerCase())) return true;
  if ((method || '').toLowerCase() !== 'post') return false;
  if (route.startsWith('/profitability/')) return !['/profitability/monthly-report', '/profitability/monthly-report/screen'].includes(route);
  if (/^\/(loadingterminal|loading-terminal|terminal|location|employee|company|remark|cashexpense|account)\//.test(route)) {
    return /\/(create-|update-|delete-|activate-|insert-|recalculate-|enter-|reset-|save-|cancel-|manage-|add-)/.test(route);
  }
  return /^\/(employee-activity|agent-activity)\/(charging-machine|withdrawn-frombank|terminal-withdrawal|terminal-withdrawal-historical|split-withdrawaltoemployee|split-money|split-to-employees)$/.test(route)
    || route.startsWith('/cashmanagement/');
};
